var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "enhancements" },
    [
      _c("booking-header-extension", { ref: "header" }, [
        _c("div", { staticClass: "booking-header-extension-left" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.wWidth < 1024
                    ? _vm.tc(
                        "enhancements.complimentaryEnhancementsMobileTitle"
                      )
                    : _vm.tc(
                        "enhancements.complimentaryEnhancementsDesktopTitle"
                      )
                ) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "booking-header-extension-right" }, [
          _c("div", { staticClass: "count" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.tc("enhancements.addOnsAndEnhancementsAdded", {
                    totalNumberOfAddOnsEnhancementsAdded:
                      _vm.enhancementsInRoom.length + _vm.addOnsInRoom.length,
                  })
                ) +
                "\n      "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.isBookingEditMode
        ? _c(
            "div",
            { staticClass: "editing-reservation-banner__container" },
            [_c("modify-edit-banner", { attrs: { "is-room-list": false } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "enhancements-wrapper" }, [
        _c("div", { staticClass: "enhancements-content" }, [
          _c("span", { staticClass: "enhancements-content-header-badge" }, [
            _vm._v(
              _vm._s(
                _vm
                  .tc("enhancements.memberTitleForEnhancementSection")
                  .replace("{0}", _vm.userTier)
              )
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showComplimentaryPrivileges,
              expression: "showComplimentaryPrivileges",
            },
          ],
          staticClass: "enhancements-wrapper",
        },
        [
          _c(
            "div",
            { staticClass: "enhancements-content zero-padding" },
            [
              _c("div", { staticClass: "enhancements-content-header" }, [
                _c("div", [
                  _c(
                    "h1",
                    { staticClass: "enhancements-content-header-title" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.tc("enhancements.enhancementsTitle")) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "enhancements-content-header-description",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.tc("enhancements.enhancementsDescription")
                      ),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "enhancements-content-header-counter",
                    attrs: { role: "status" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.tc("enhancements.enhancementsAdded", {
                            numberOfEnhancementsAdded:
                              _vm.totalNumberOfSelectableEnhancements,
                            numberOfEnhancementsAllowed:
                              _vm.enhancementsAllowed,
                          })
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("enhancements-list", {
                attrs: {
                  "enhancements-list": _vm.enhancementsList,
                  "selected-enhancements":
                    _vm.totalNumberOfSelectableEnhancements,
                  "ignore-max-number": false,
                },
                on: {
                  "select-enhancement": _vm.selectEnhancement,
                  "remove-enhancement": _vm.removeEnhancement,
                  "edit-enhancement": function ($event) {
                    _vm.selectedEnhancement = $event
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasAutoIncludedEnhancements,
              expression: "hasAutoIncludedEnhancements",
            },
          ],
          staticClass: "enhancements-wrapper",
        },
        [
          _c(
            "div",
            { staticClass: "enhancements-content zero-padding" },
            [
              _c("div", { staticClass: "enhancements-content-header" }, [
                _c("div", [
                  _c(
                    "h1",
                    { staticClass: "enhancements-content-header-subtitle" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm
                              .tc("enhancements.selectMemberBenefitTitle")
                              .replace("{0}", this.userTier)
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "enhancements-content-header-description",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm
                          .tc("enhancements.selectMemberBenefitDescription")
                          .replace("{0}", this.userTier)
                      ),
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("enhancements-list", {
                attrs: {
                  "enhancements-list": _vm.defaultSelectedEnhancements,
                  "ignore-max-number": true,
                  "selected-enhancements": 0,
                },
                on: {
                  "select-enhancement": _vm.selectEnhancement,
                  "remove-enhancement": _vm.removeEnhancement,
                  "edit-enhancement": function ($event) {
                    _vm.selectedEnhancement = $event
                  },
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showAddOns ? _c("booking-add-ons") : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "slide-right" } },
        [
          _vm.selectedEnhancement
            ? _c("enhancement-user-input", {
                attrs: { "outer-activator": _vm.activator },
                on: { done: _vm.enhancementEdited, deactivate: _vm.deactivate },
                model: {
                  value: _vm.selectedEnhancement,
                  callback: function ($$v) {
                    _vm.selectedEnhancement = $$v
                  },
                  expression: "selectedEnhancement",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.selectedEnhancement
          ? _c("div", {
              staticClass: "backlight",
              on: { click: _vm.deactivate },
            })
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }